import {atom} from "recoil";

const appConfigState = atom({
  key: 'appConfigState',
  default: {
    refreshInterval: 3000
  },
});

export default appConfigState;